import React, { useState } from 'react';

// Mentions légales et information sur les données de la page d'attente.
// Informations issues de l'extrait Kbis (immatriculation au RCS de Paris le 13 octobre 2026).
const SOCIETE = {
  nom: 'Nowatt',
  forme: 'Société à responsabilité limitée (SARL) au capital de 1\u00A0000\u00A0€',
  siege: '14 rue de Dunkerque, 75010 Paris',
  rcs: 'RCS Paris 131 419 087',
  directeur: 'Amar Benayada, gérant',
  email: 'contact@nowatt.app',
};

const Section = ({ title, children }) => (
  <section style={s.section}>
    <h2 style={s.h2}>{title}</h2>
    <div style={s.body}>{children}</div>
  </section>
);

const Mail = () => <a href={`mailto:${SOCIETE.email}`} style={s.link}>{SOCIETE.email}</a>;

const Mentions = () => (
  <>
    <Section title="Éditeur du site">
      <p>
        {SOCIETE.nom}<br />
        {SOCIETE.forme}<br />
        Siège social : {SOCIETE.siege}<br />
        {SOCIETE.rcs}<br />
        Contact : <Mail />
      </p>
    </Section>
    <Section title="Directeur de la publication">
      <p>{SOCIETE.directeur}</p>
    </Section>
    <Section title="Hébergement">
      <p>
        Site : Vercel Inc., 440 N Barranca Ave #4133, Covina, CA 91723, États-Unis — vercel.com
      </p>
      <p style={{ marginTop: 10 }}>
        Serveurs applicatifs : Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen, Allemagne — hetzner.com
      </p>
    </Section>
    <Section title="Médiation de la consommation">
      <p>
        Conformément aux dispositions du Code de la consommation concernant « le processus de médiation des litiges
        de la consommation », après nous avoir sollicités et à défaut de réponse vous satisfaisant, vous avez la
        possibilité de recourir gratuitement à une procédure de médiation de la consommation auprès de :
      </p>
      <p style={{ marginTop: 10 }}>
        CM2C<br />
        49 rue de Ponthieu, 75008 Paris<br />
        Tél. : 01 89 47 00 14<br />
        Site internet : <a href="https://www.cm2c.net/declarer-un-litige.php" target="_blank" rel="noopener noreferrer" style={s.link}>https://www.cm2c.net/declarer-un-litige.php</a>
      </p>
    </Section>
    <Section title="Propriété intellectuelle">
      <p>
        Le nom Nowatt, le logo, les textes et l'ensemble des éléments de ce site appartiennent à la société {SOCIETE.nom}.
        Toute reproduction sans autorisation est interdite.
      </p>
    </Section>
  </>
);

const Donnees = () => (
  <>
    <Section title="Ce que nous collectons">
      <p>
        Sur cette page, nous collectons uniquement l'adresse email que vous nous laissez volontairement
        pour être prévenu du lancement de Nowatt.
      </p>
    </Section>
    <Section title="Pourquoi">
      <p>
        Votre adresse sert seulement à vous informer du lancement du service et à vous en présenter les détails.
        Elle n'est ni vendue, ni louée, ni cédée à qui que ce soit. Ce traitement repose sur votre consentement,
        que vous pouvez retirer à tout moment.
      </p>
    </Section>
    <Section title="Combien de temps">
      <p>
        Nous conservons votre adresse jusqu'au lancement du service, puis au plus 3 ans après notre dernier
        contact avec vous, sauf si vous nous demandez de la supprimer avant.
      </p>
    </Section>
    <Section title="Qui y a accès">
      <p>
        Seule l'équipe Nowatt, ainsi que nos prestataires techniques (hébergement, envoi d'emails),
        strictement pour faire fonctionner le service.
      </p>
    </Section>
    <Section title="Vos droits">
      <p>
        Vous pouvez à tout moment accéder à votre adresse, la corriger, la faire supprimer ou vous opposer
        à son utilisation, en écrivant à <Mail />. Vous pouvez aussi adresser une réclamation à la CNIL
        (cnil.fr).
      </p>
    </Section>
    <Section title="Responsable du traitement">
      <p>{SOCIETE.nom}, {SOCIETE.siege} — <Mail /></p>
    </Section>
    <Section title="Cookies">
      <p>Cette page n'utilise aucun cookie publicitaire ni outil de suivi.</p>
    </Section>
  </>
);

export default function MentionsLegales({ onBack, initialTab = 'mentions' }) {
  const [tab, setTab] = useState(initialTab);

  return (
    <div style={s.page}>
      <style>{`
        .ml-tab:focus-visible, .ml-back:focus-visible { outline: 2px solid #C8F135; outline-offset: 2px; }
        .ml-back:hover { color: #EEF2FF; border-color: rgba(238,242,255,0.3); }
      `}</style>
      <nav style={s.nav}>
        <div style={s.brand}>
          <img src="/favicon_nowatt.png" alt="" style={s.mark} />
          <span style={s.word}><span style={{ color: '#C8F135' }}>No</span>watt</span>
        </div>
        <button className="ml-back" onClick={onBack} style={s.back}>← Retour</button>
      </nav>

      <main style={s.main}>
        <div style={s.tabs} role="tablist">
          {[['mentions', 'Mentions légales'], ['donnees', 'Vos données']].map(([key, label]) => (
            <button
              key={key} className="ml-tab" role="tab" aria-selected={tab === key}
              onClick={() => setTab(key)}
              style={{ ...s.tab, ...(tab === key ? s.tabOn : null) }}
            >{label}</button>
          ))}
        </div>
        <h1 style={s.h1}>{tab === 'mentions' ? 'Mentions légales' : 'Vos données personnelles'}</h1>
        {tab === 'mentions' ? <Mentions /> : <Donnees />}
      </main>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#06080C', color: '#EEF2FF', fontFamily: "'Plus Jakarta Sans', sans-serif" },
  nav: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12,
    padding: '18px 16px', maxWidth: 760, margin: '0 auto', borderBottom: '1px solid rgba(238,242,255,0.06)',
  },
  brand: { display: 'flex', alignItems: 'center', gap: 10 },
  mark: { width: 28, height: 33 },
  word: { color: '#EEF2FF', fontFamily: "'Lexend', sans-serif", fontWeight: 800, fontSize: '1.25rem', letterSpacing: '-0.02em' },
  back: {
    background: 'transparent', color: 'rgba(238,242,255,0.6)', border: '1px solid rgba(238,242,255,0.15)',
    borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontSize: '0.85rem', fontFamily: 'inherit',
  },
  main: { maxWidth: 760, margin: '0 auto', padding: '32px 16px 64px', boxSizing: 'border-box' },
  tabs: { display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 28 },
  tab: {
    background: 'transparent', color: 'rgba(238,242,255,0.5)', border: '1px solid rgba(238,242,255,0.1)',
    borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: '0.88rem', fontFamily: 'inherit',
  },
  tabOn: { background: 'rgba(200,241,53,0.12)', color: '#C8F135', border: '1px solid rgba(200,241,53,0.3)' },
  h1: { fontFamily: "'Lexend', sans-serif", fontSize: '1.7rem', fontWeight: 700, margin: '0 0 28px' },
  section: { marginBottom: 26 },
  h2: { fontFamily: "'Lexend', sans-serif", fontSize: '1.02rem', fontWeight: 700, color: '#C8F135', margin: '0 0 8px' },
  body: { color: 'rgba(238,242,255,0.72)', fontSize: '0.9rem', lineHeight: 1.75 },
  link: { color: '#C8F135' },
};
